import { useSyncExternalStore } from 'react'

/** Whether a CSS media query matches, following it as the window changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (fn) => {
      const m = window.matchMedia(query)
      m.addEventListener('change', fn)
      return () => {
        m.removeEventListener('change', fn)
      }
    },
    () => window.matchMedia(query).matches,
  )
}
